import _ from 'lodash';

const getProductsByPromos = (products = [], promos) =>
  _.filter(
    products,
    (p) =>
      !!_.filter(p.Product.ProductTags, (c) =>
        promos?.length > 0 ? !!_.find(promos, { Id: c.TagId }) : true
      )?.length
  );

const getProductsByFulfillmentPlants = (products = [], fulfillmentPlants) =>
  _.filter(
    products,
    (p) =>
      !!_.filter(p.PrintProviders, (c) =>
        fulfillmentPlants?.length > 0
          ? !!_.find(fulfillmentPlants, (f) => f === c?.ProviderName)
          : true
      )?.length
  );

const getProductsByCategoryIds = (products = [], categoryIds) =>
  _.filter(
    products,
    (p) =>
      !!_.filter(p.Product.CategoryIds, (c) =>
        categoryIds?.length > 0
          ? !!_.find(categoryIds, (x) => x === c.CatId)
          : true
      )?.length
  );

const getProductsByPrintProvider = (products = [], printProvider) =>
  _.filter(
    products,
    (p) => !!_.find(p.PrintProviders, (x) => x.ProviderName === printProvider)
  );

const getProdShipCostByDestAndPP = (
  products = [],
  providerName,
  destination,
  highestProduct,
  quantity,
  countries
) => {
  const selectedProduct = _.find(
    products,
    (c) => c?.Product?.ID === highestProduct?.ProductID
  );

  const selectedPrintProvider = _.find(
    selectedProduct?.PrintProviders,
    (c) => c?.ProviderName === providerName
  );

  const shippingDestination =
    providerName === 'AU'
      ? destination !== 'AU' && destination !== 'NZ'
        ? 'Intl'
        : destination
      : providerName === 'EU'
      ? countries?.find((c) => c?.code2 === destination)?.region === 'Europe'
        ? 'EU'
        : 'Intl'
      : destination !== 'US' && destination !== 'CA'
      ? 'Intl'
      : destination;

  const shippingCostInfo = _.find(
    selectedPrintProvider?.ShippingCosts,
    (c) => c?.ShippingDestination === shippingDestination
  );

  const cost =
    1 * shippingCostInfo?.PrimaryCost +
    (quantity === 1 ? 0 : quantity - 1) * shippingCostInfo?.SecondaryCost;

  return {
    cost,
    maxDays: shippingCostInfo?.ShippingTimeMaxInDays,
    minDays: shippingCostInfo?.ShippingTimeMinInDays,
  };
};

const getSKUFromProductId = (products = [], productId) =>
  _.find(products, (p) => p?.Product?.ID === productId)?.Product?.SKU;

const getProductFromSkuAndPrintProvider = (products = [], sku, printProvider) =>
  _.find(
    products,
    (p) =>
      p?.Product?.SKU === sku &&
      !!p?.PrintProviders?.find((pp) => pp?.ProviderName === printProvider)
  );

const getDTGPlusFromProductId = (products = [], productId) =>
  _.find(products, (p) => p?.Product?.ID === productId)?.DTGPlus;

const getPrintTypeFromProductId = (products = [], productId) =>
  _.find(products, (p) => p?.Product?.ID === productId)?.Product?.PrintType;

const getDesignerSettingsFromProductId = (
  products = [],
  productId,
  isBack = false
) => {
  const product = _.find(products, (p) => p?.Product?.ID === productId);

  if (isBack && product?.BackDesignerSettings) {
    return product?.BackDesignerSettings;
  }
  return product?.DesignerSettings;
};

const productHasBackDesignerSettings = (products = [], productId) =>
  _.find(products, (p) => p?.Product?.ID === productId)?.BackDesignerSettings;

const getMarketingImagePathFromProductId = (
  products = [],
  productId,
  ColorId
) => {
  const product = _.find(products, (p) => p?.Product?.ID === productId);
  return _.find(product?.Colors, (p) => p?.ID === ColorId)?.Image;
};

const isSub = (products = [], productId) =>
  !!_.find(
    products,
    (p) => p?.Product?.ID === productId && p?.Product?.PrintType === 'SUB'
  );

const isAOP = (products = [], productId) =>
  !!_.find(
    products,
    (p) => p?.Product?.ID === productId && p?.Product?.PrintType === 'AOP'
  );

const isDecorationNotNeeded = (products = [], productId) =>
  !!_.find(
    products,
    (p) =>
      p?.Product?.ID === productId && p?.Product?.DecorationNeeded === false
  );

const getArtworkSettingsProductId = (products = [], productId) =>
  _.find(products, (p) => p?.Product?.ID === productId)?.ArtworkSettings;

const getProductAdditionalImages = (products = [], productId) =>
  _.find(products, (p) => p?.Product?.ID === productId)?.AdditionalImages;

const getAdditionalTechniquesFromProductId = (
  products = [],
  productId,
  isBack = false,
  printType
) => {
  const product = _.find(products, (p) => p?.Product?.ID === productId);
  const additionalTechniquesArtSettings =
    product?.AdditionalTechniquesArtSettings;

  const designerSettings = additionalTechniquesArtSettings?.find(
    (p) => p?.name === printType
  );

  if (designerSettings) {
    const artSettings = designerSettings?.artSettings;
    const back = artSettings?.find((p) => p?.areaName === 'Back');
    const front = artSettings?.find((p) => p?.areaName === 'Front');
    if (isBack && back) {
      return back?.areaSettings;
    }
    return front?.areaSettings;
  }
};

export {
  getProductsByPromos,
  getProductsByCategoryIds,
  getProductsByPrintProvider,
  getProdShipCostByDestAndPP,
  getSKUFromProductId,
  getDesignerSettingsFromProductId,
  getPrintTypeFromProductId,
  getProductsByFulfillmentPlants,
  isSub,
  getMarketingImagePathFromProductId,
  productHasBackDesignerSettings,
  getDTGPlusFromProductId,
  getArtworkSettingsProductId,
  isAOP,
  getProductAdditionalImages,
  getAdditionalTechniquesFromProductId,
  isDecorationNotNeeded,
  getProductFromSkuAndPrintProvider,
};
